export default __webpack_public_path__ + "static/media/CabinetGrotesk-Bold.c9c3bc30.woff2";